export default class RoleModel {
	constructor(data = {}) {
		this.id = data.id;
		this.name = data.name || null;
		this.description = data.description || null;
		this.role_permissions = data.role_permissions || [];
	}
}
